module.exports = __webpack_public_path__ + "assets/img/img135.e0e8218a.png";